import { SELF_PARTICIPANT_ID } from '../../call-mobile/constants';
import { StreamType, defaultBackgroundEffects } from '../constants';
export const initialState = {
    activeStreamId: null,
    currentStreamId: null,
    pinnedStreamId: null,
    connectionStatus: {},
    participants: [],
    selfParticipant: {
        id: SELF_PARTICIPANT_ID,
        uuid: '',
        name: 'You',
        hasAudio: false,
        hasVideo: false,
        avatar: '',
        videoElementPromise: null,
        streamType: StreamType.Camera,
    },
    participantsPublisherErrors: new Set(),
    isSelfPublisherError: false,
    selfPublisherErrors: [],
    isSelfPreviewVisible: true,
    isSelfPreviewLoading: true,
    backgroundEffect: defaultBackgroundEffects[0],
    isPiPTurnedOn: false,
    isEndCallAttempt: false,
    isPreviewsListVisible: true,
    isClosedCaptionsOpen: false,
};
export default function callReducer(state = initialState, { type, payload } = {}) {
    switch (type) {
        case 'CALL/SET_ACTIVE_STREAM_ID':
            return { ...state, activeStreamId: payload };
        case 'CALL/SET_CURRENT_STREAM_ID':
            return { ...state, currentStreamId: payload };
        case 'CALL/SET_PARTICIPANTS_CONNECTION_STATUS':
            return {
                ...state,
                connectionStatus: {
                    ...state.connectionStatus,
                    [payload.uuid]: payload.state,
                },
            };
        case 'CALL/SET_PINNED_STREAM_ID':
            return { ...state, pinnedStreamId: payload };
        case 'CALL/SET_PARTICIPANTS':
            return { ...state, participants: payload };
        case 'CALL/UPDATE_PARTICIPANT':
            return {
                ...state,
                participants: state.participants.map((participant) => {
                    return participant.id === payload.id
                        ? { ...participant, ...payload.data }
                        : participant;
                }),
            };
        case 'CALL/SET_SELF_PARTICIPANT':
            return {
                ...state,
                selfParticipant: { ...state.selfParticipant, ...payload },
            };
        case 'CALL/SET_PUBLISHER_ERRORS':
            return { ...state, participantsPublisherErrors: payload };
        case 'CALL/SET_SELF_PUBLISHER_ERROR':
            return { ...state, isSelfPublisherError: payload };
        case 'CALL/ADD_SELF_PUBLISHER_ERROR':
            return {
                ...state,
                selfPublisherErrors: [...state.selfPublisherErrors, payload],
            };
        case 'CALL/SHOW_SELF_PREVIEW':
            return { ...state, isSelfPreviewVisible: true };
        case 'CALL/HIDE_SELF_PREVIEW':
            return { ...state, isSelfPreviewVisible: false };
        case 'CALL/SET_BACKGROUND_EFFECT':
            return { ...state, backgroundEffect: payload };
        case 'CALL/SET_IS_PIP_TURNED_ON':
            return { ...state, isPiPTurnedOn: true };
        case 'CALL/SET_IS_PIP_TURNED_OFF':
            return { ...state, isPiPTurnedOn: false };
        case 'CALL/SET_END_CALL_ATTEMPT':
            return { ...state, isEndCallAttempt: payload };
        case 'CALL/SET_IS_SELF_PREVIEW_LOADING':
            return { ...state, isSelfPreviewLoading: payload };
        case 'CALL/SHOW_PREVIEWS_LIST':
            return { ...state, isPreviewsListVisible: true };
        case 'CALL/HIDE_PREVIEWS_LIST':
            return { ...state, isPreviewsListVisible: false };
        case 'CALL/SET_IS_CLOSED_CAPTIONS_OPEN':
            return { ...state, isClosedCaptionsOpen: payload };
        default:
            return state;
    }
}
